import { createSlice } from "@reduxjs/toolkit";
import Api from "../api/Api";

type State = {
  token: string | null;
  isGeneratingToken: boolean;
  error: Object | null;
};
const INITIAL_STATE = {
  token: null,
  isGeneratingToken: true,
  error: null,
};

// Redux staat en reducers voor de API token
const apiToken = createSlice({
  name: "apiToken",
  initialState: INITIAL_STATE,
  reducers: {
    generateTokenStart: (state: State) => {
      state.isGeneratingToken = true;
      state.error = null;
    },
    generateTokenSuccess: (state: State, action) => {
      state.isGeneratingToken = false;
      state.token = action.payload;
    },
    generateTokenFailed: (state: State, action) => {
      state.isGeneratingToken = false;
      state.error = action.payload;
    },
    resetTokenState: (state: State) => {
      return INITIAL_STATE;
    },
  },
});

export default apiToken.reducer;

const {
  generateTokenStart,
  generateTokenSuccess,
  generateTokenFailed,
} = apiToken.actions;


/**
 * Async action creator voor het genereren van een token
 * @param userId - Optional user ID for which the token should be generated
 * @returns 
 */
export const generateApiToken = (userId? : string) => async (dispatch: Function) => {
  try {
    dispatch(generateTokenStart());
    const api = new Api();
    let payload = {};
    if (userId) {
      payload = { userId };
    }
    const result = await api.postCreateToken(payload);
    
    if (result && result.token) {
      dispatch(generateTokenSuccess(result.token));
      return result.token; 
    } else {
      throw new Error("Token generation failed: Invalid response format");
    }
  } catch (err) {
    dispatch(generateTokenFailed(err));
    throw err; 
  }
};